import { useStaticQuery, graphql } from 'gatsby';

export const useLocalizedNews = (selectedLocale, numItems = 0) => {
  const {
    allPrismicNewsList: { edges: newsList },
    allPrismicNews: { edges: news },
  } = useStaticQuery(graphql`
    query {
      allPrismicNewsList {
        edges {
          node {
            lang
            data {
              no_news {
                text
              }
              title {
                text
              }
            }
          }
        }
      }

      allPrismicNews(sort: { order: DESC, fields: data___date }) {
        edges {
          node {
            uid
            lang
            data {
              date
              title {
                text
              }
              short_description {
                html
              }
              type
              read_more_text
              image {
                alt
                localFile {
                  childImageSharp {
                    fluid(maxWidth: 400, maxHeight: 250) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  const newsArray = news.filter(({ node }) => node.lang === selectedLocale);

  return {
    list: newsList.filter(({ node }) => node.lang === selectedLocale),
    news: numItems ? newsArray.slice(0, numItems) : newsArray,
  };
};
